/** Packages **/
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { openTimeSearch } from '../../data/constants';
import './styles.scss';

class OpenTimeSearchHead extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isAscending: true
    };
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    this.setState({
      isAscending: nextProps.sortDirection === 'ASCENDING'
    });
  }

  sortBy = e => {
    const criteria = e.target.dataset.criteria;
    let isAscending = !this.state.isAscending;
    if (criteria !== this.props.sortCriteria) {
      isAscending = true;
    }

    this.props.handleSort(criteria, isAscending);
  };

  buildSortingIcon = (columnHeader, sortBy) => {
    if (this.props.sortCriteria !== columnHeader.STRING) {
      return '';
    }
    const isAscending = this.state.isAscending;
    const sortingClassName = isAscending
      ? openTimeSearch.sortCriteria.CLASSNAME_ASCENDING
      : openTimeSearch.sortCriteria.CLASSNAME_DESCENDING;
    return (
      <i
        className={sortingClassName}
        data-criteria={columnHeader.STRING}
        onClick={e => sortBy(e)}
      />
    );
  };
  render() {
    const columnHeaders = openTimeSearch.sortArray.map((columnHeader, key) => {
      const identifier = columnHeader.IDENTIFIER;

      const isSortable = columnHeader.SORTABLE;
      const sortingIcon = this.buildSortingIcon(columnHeader, this.sortBy);

      return (
        <div
          key={key}
          className={columnHeader.CLASSNAME}
          style={columnHeader.HANDLE_REFRESH ? { width: '8.7%' } : {}}
        >
          <span
            data-criteria={columnHeader.STRING}
            onClick={isSortable ? this.sortBy : () => { }}
          >
            {identifier}
            {sortingIcon}
          </span>
          {columnHeader.HANDLE_REFRESH ? (
            <i
              className='fa fa-rotate-right'
              onClick={this.props.handleRefresh}
              style={{ cursor: 'pointer' }}
            ></i>
          ) : null}
        </div>
      );
    });
    return <div className='row Table-Head'>{columnHeaders}</div>;
  }
}

OpenTimeSearchHead.propTypes = {
  handleSort: PropTypes.func.isRequired,
  handleRefresh: PropTypes.func.isRequired,
  sortCriteria: PropTypes.string,
  sortDirection: PropTypes.string,
  isFetchingBidAnalyzer: PropTypes.bool.isRequired
};

OpenTimeSearchHead.defaultProps = {
  sortCriteria: '',
  sortDirection: ''
};

export default OpenTimeSearchHead;
